 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AccountAdd~AccountEdit~AccountManagement~AddStudentInfo~AnalysisChart~Class~EditStudentInfo~ImportSt~79c79eec":"AccountAdd~AccountEdit~AccountManagement~AddStudentInfo~AnalysisChart~Class~EditStudentInfo~ImportSt~79c79eec","AccountAdd":"AccountAdd","AccountEdit":"AccountEdit","AccountManagement":"AccountManagement","AddStudentInfo":"AddStudentInfo","AnalysisChart":"AnalysisChart","Class":"Class","EditStudentInfo":"EditStudentInfo","ImportStudent":"ImportStudent","Recycle~ScreeningListQuery~Student":"Recycle~ScreeningListQuery~Student","Recycle":"Recycle","SchoolReport~ScreeningListQuery":"SchoolReport~ScreeningListQuery","ScreeningListQuery~barCode":"ScreeningListQuery~barCode","ScreeningListQuery":"ScreeningListQuery","Student":"Student","SchoolAdd~SchoolEdit":"SchoolAdd~SchoolEdit","SchoolAdd":"SchoolAdd","SchoolEdit":"SchoolEdit","SchoolList":"SchoolList","SchoolManagement":"SchoolManagement","SchoolReport":"SchoolReport","barCode":"barCode","ScreeningPlanAdd":"ScreeningPlanAdd","ScreeningPlanEdit":"ScreeningPlanEdit","ScreeningPlanList":"ScreeningPlanList","classStudentsImport":"classStudentsImport","government":"government","governmentAdd":"governmentAdd","governmentEdit":"governmentEdit","grade":"grade","gradeAdd":"gradeAdd","gradeEdit":"gradeEdit","historicalData":"historicalData","homeGovernment":"homeGovernment","homeGrade":"homeGrade","homeOrganization":"homeOrganization","homeSchool":"homeSchool","importKaramayEdition":"importKaramayEdition","importScreeningData":"importScreeningData","login":"login","messageCenter":"messageCenter","monitoringKanban":"monitoringKanban","monitoringManagement":"monitoringManagement","organization":"organization","organizationAdd":"organizationAdd","organizationEdit":"organizationEdit","record":"record","recordEdit":"recordEdit","school":"school","schoolAdd":"schoolAdd","schoolAdministrator":"schoolAdministrator","schoolAdministratorAdd":"schoolAdministratorAdd","schoolAdministratorEdit":"schoolAdministratorEdit","schoolClass":"schoolClass","schoolClassAdd":"schoolClassAdd","schoolClassEdit":"schoolClassEdit","schoolClassManagement":"schoolClassManagement","schoolClassManagementAdd":"schoolClassManagementAdd","schoolClassManagementEdit":"schoolClassManagementEdit","schoolEdit":"schoolEdit","schoolGradeManagement":"schoolGradeManagement","schoolGradeManagementAdd":"schoolGradeManagementAdd","schoolGradeManagementEdit":"schoolGradeManagementEdit","schoolSet":"schoolSet","schoolStudentsImport":"schoolStudentsImport","studentManagement":"studentManagement","studentManagementAdd~studentManagementEdit":"studentManagementAdd~studentManagementEdit","studentManagementAdd":"studentManagementAdd","studentManagementEdit":"studentManagementEdit","studentTesthistory":"studentTesthistory","teacher":"teacher","teacherAdd":"teacherAdd","teacherEdit":"teacherEdit","teacherManage":"teacherManage","teacherManageAdd":"teacherManageAdd","teacherManageEdit":"teacherManageEdit","home":"home"}[chunkId]||chunkId) + "." + {"AccountAdd~AccountEdit~AccountManagement~AddStudentInfo~AnalysisChart~Class~EditStudentInfo~ImportSt~79c79eec":"4a508d0c","AccountAdd":"3e51ae67","AccountEdit":"1ce7142e","AccountManagement":"8cdfb8ec","AddStudentInfo":"77cdf371","AnalysisChart":"1a3c7d65","Class":"c763753a","EditStudentInfo":"18573cd3","ImportStudent":"96900a65","Recycle~ScreeningListQuery~Student":"e4cdbb52","Recycle":"cb777870","SchoolReport~ScreeningListQuery":"a1aa9264","ScreeningListQuery~barCode":"d786fd37","ScreeningListQuery":"1697435a","Student":"a53f7da4","SchoolAdd~SchoolEdit":"149aa6ba","SchoolAdd":"1fc63ab9","SchoolEdit":"87b72b52","SchoolList":"124f79a0","SchoolManagement":"48547aa0","SchoolReport":"f194e215","barCode":"bcfae05c","ScreeningPlanAdd":"76f1a154","ScreeningPlanEdit":"578e0674","ScreeningPlanList":"4e6d545e","classStudentsImport":"ef0ae462","government":"13cff96f","governmentAdd":"fad84636","governmentEdit":"01a0456d","grade":"8e9e8d81","gradeAdd":"b6d129bc","gradeEdit":"37f79a9c","historicalData":"cea8d40c","homeGovernment":"92a1d49a","homeGrade":"dd85a3b6","homeOrganization":"ed9a427b","homeSchool":"7bb139fa","importKaramayEdition":"35aa3c07","importScreeningData":"ae4ba730","login":"b563ccf2","messageCenter":"fe5cd9ea","monitoringKanban":"a3276b5c","monitoringManagement":"0d1b19a7","organization":"a90c6e30","organizationAdd":"41c8c573","organizationEdit":"7c95cd03","record":"8c2f452c","recordEdit":"74b04c4b","school":"c9d6d8ef","schoolAdd":"f05bb281","schoolAdministrator":"276a8115","schoolAdministratorAdd":"643b51f6","schoolAdministratorEdit":"8dc95f1c","schoolClass":"23ccb44d","schoolClassAdd":"23312313","schoolClassEdit":"969cfc39","schoolClassManagement":"7cc0cecc","schoolClassManagementAdd":"e91a214f","schoolClassManagementEdit":"51e69e8e","schoolEdit":"c08892fb","schoolGradeManagement":"0ca6aca1","schoolGradeManagementAdd":"10c5e494","schoolGradeManagementEdit":"ef627ffa","schoolSet":"efff87d5","schoolStudentsImport":"fc278e52","studentManagement":"82847801","studentManagementAdd~studentManagementEdit":"f81618c7","studentManagementAdd":"845399bc","studentManagementEdit":"b2b1490c","studentTesthistory":"d6898e69","teacher":"aeec035e","teacherAdd":"92cc58c9","teacherEdit":"35f953c7","teacherManage":"12a1508f","teacherManageAdd":"090cba8e","teacherManageEdit":"e3ad77f3","home":"d592f9b6","chunk-2d215faa":"9e3de049","chunk-2d216214":"31a8d941","chunk-60a5769a":"47a3fb60"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"AccountAdd":1,"AccountEdit":1,"AccountManagement":1,"AddStudentInfo":1,"AnalysisChart":1,"Class":1,"EditStudentInfo":1,"ImportStudent":1,"Recycle":1,"ScreeningListQuery":1,"Student":1,"SchoolAdd":1,"SchoolEdit":1,"SchoolList":1,"SchoolManagement":1,"SchoolReport":1,"barCode":1,"ScreeningPlanAdd":1,"ScreeningPlanEdit":1,"ScreeningPlanList":1,"classStudentsImport":1,"government":1,"governmentAdd":1,"governmentEdit":1,"grade":1,"gradeAdd":1,"gradeEdit":1,"historicalData":1,"homeGovernment":1,"homeGrade":1,"homeOrganization":1,"homeSchool":1,"importKaramayEdition":1,"importScreeningData":1,"login":1,"messageCenter":1,"monitoringKanban":1,"monitoringManagement":1,"organization":1,"organizationAdd":1,"organizationEdit":1,"record":1,"recordEdit":1,"school":1,"schoolAdd":1,"schoolAdministrator":1,"schoolAdministratorAdd":1,"schoolAdministratorEdit":1,"schoolClass":1,"schoolClassAdd":1,"schoolClassEdit":1,"schoolClassManagement":1,"schoolClassManagementAdd":1,"schoolClassManagementEdit":1,"schoolEdit":1,"schoolGradeManagement":1,"schoolGradeManagementAdd":1,"schoolGradeManagementEdit":1,"schoolSet":1,"schoolStudentsImport":1,"studentManagement":1,"studentManagementAdd~studentManagementEdit":1,"studentManagementAdd":1,"studentManagementEdit":1,"studentTesthistory":1,"teacher":1,"teacherAdd":1,"teacherEdit":1,"teacherManage":1,"teacherManageAdd":1,"teacherManageEdit":1,"home":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AccountAdd~AccountEdit~AccountManagement~AddStudentInfo~AnalysisChart~Class~EditStudentInfo~ImportSt~79c79eec":"AccountAdd~AccountEdit~AccountManagement~AddStudentInfo~AnalysisChart~Class~EditStudentInfo~ImportSt~79c79eec","AccountAdd":"AccountAdd","AccountEdit":"AccountEdit","AccountManagement":"AccountManagement","AddStudentInfo":"AddStudentInfo","AnalysisChart":"AnalysisChart","Class":"Class","EditStudentInfo":"EditStudentInfo","ImportStudent":"ImportStudent","Recycle~ScreeningListQuery~Student":"Recycle~ScreeningListQuery~Student","Recycle":"Recycle","SchoolReport~ScreeningListQuery":"SchoolReport~ScreeningListQuery","ScreeningListQuery~barCode":"ScreeningListQuery~barCode","ScreeningListQuery":"ScreeningListQuery","Student":"Student","SchoolAdd~SchoolEdit":"SchoolAdd~SchoolEdit","SchoolAdd":"SchoolAdd","SchoolEdit":"SchoolEdit","SchoolList":"SchoolList","SchoolManagement":"SchoolManagement","SchoolReport":"SchoolReport","barCode":"barCode","ScreeningPlanAdd":"ScreeningPlanAdd","ScreeningPlanEdit":"ScreeningPlanEdit","ScreeningPlanList":"ScreeningPlanList","classStudentsImport":"classStudentsImport","government":"government","governmentAdd":"governmentAdd","governmentEdit":"governmentEdit","grade":"grade","gradeAdd":"gradeAdd","gradeEdit":"gradeEdit","historicalData":"historicalData","homeGovernment":"homeGovernment","homeGrade":"homeGrade","homeOrganization":"homeOrganization","homeSchool":"homeSchool","importKaramayEdition":"importKaramayEdition","importScreeningData":"importScreeningData","login":"login","messageCenter":"messageCenter","monitoringKanban":"monitoringKanban","monitoringManagement":"monitoringManagement","organization":"organization","organizationAdd":"organizationAdd","organizationEdit":"organizationEdit","record":"record","recordEdit":"recordEdit","school":"school","schoolAdd":"schoolAdd","schoolAdministrator":"schoolAdministrator","schoolAdministratorAdd":"schoolAdministratorAdd","schoolAdministratorEdit":"schoolAdministratorEdit","schoolClass":"schoolClass","schoolClassAdd":"schoolClassAdd","schoolClassEdit":"schoolClassEdit","schoolClassManagement":"schoolClassManagement","schoolClassManagementAdd":"schoolClassManagementAdd","schoolClassManagementEdit":"schoolClassManagementEdit","schoolEdit":"schoolEdit","schoolGradeManagement":"schoolGradeManagement","schoolGradeManagementAdd":"schoolGradeManagementAdd","schoolGradeManagementEdit":"schoolGradeManagementEdit","schoolSet":"schoolSet","schoolStudentsImport":"schoolStudentsImport","studentManagement":"studentManagement","studentManagementAdd~studentManagementEdit":"studentManagementAdd~studentManagementEdit","studentManagementAdd":"studentManagementAdd","studentManagementEdit":"studentManagementEdit","studentTesthistory":"studentTesthistory","teacher":"teacher","teacherAdd":"teacherAdd","teacherEdit":"teacherEdit","teacherManage":"teacherManage","teacherManageAdd":"teacherManageAdd","teacherManageEdit":"teacherManageEdit","home":"home"}[chunkId]||chunkId) + "." + {"AccountAdd~AccountEdit~AccountManagement~AddStudentInfo~AnalysisChart~Class~EditStudentInfo~ImportSt~79c79eec":"31d6cfe0","AccountAdd":"3abd05b7","AccountEdit":"733b2113","AccountManagement":"042a73e7","AddStudentInfo":"1d2931cd","AnalysisChart":"d0c4ff52","Class":"aae5e4d3","EditStudentInfo":"25439cdd","ImportStudent":"a66906a2","Recycle~ScreeningListQuery~Student":"31d6cfe0","Recycle":"a04f9137","SchoolReport~ScreeningListQuery":"31d6cfe0","ScreeningListQuery~barCode":"31d6cfe0","ScreeningListQuery":"97955aae","Student":"9d49099a","SchoolAdd~SchoolEdit":"31d6cfe0","SchoolAdd":"a67e701b","SchoolEdit":"912cb6f9","SchoolList":"80c28db0","SchoolManagement":"6f16a8dc","SchoolReport":"2488b4b0","barCode":"64b09395","ScreeningPlanAdd":"05896cef","ScreeningPlanEdit":"056c15b0","ScreeningPlanList":"e225c7a0","classStudentsImport":"1f3c7410","government":"4f6123b5","governmentAdd":"4c275d93","governmentEdit":"e3a8141b","grade":"290a037d","gradeAdd":"6e965bcd","gradeEdit":"419c3915","historicalData":"9a35c580","homeGovernment":"d1913699","homeGrade":"31357d89","homeOrganization":"876da80b","homeSchool":"8fdbc79a","importKaramayEdition":"ddb62383","importScreeningData":"2fdf4a42","login":"86ab8c80","messageCenter":"7bca7cba","monitoringKanban":"7f89ac11","monitoringManagement":"4aec4ede","organization":"9450aee7","organizationAdd":"58a1fa5a","organizationEdit":"2e1f41c6","record":"c19dcbfa","recordEdit":"26fe6866","school":"9ce2dee6","schoolAdd":"d7f79868","schoolAdministrator":"0d2c37c6","schoolAdministratorAdd":"7af51c4f","schoolAdministratorEdit":"f098c445","schoolClass":"402945e7","schoolClassAdd":"89f2bdae","schoolClassEdit":"326cb76c","schoolClassManagement":"f8963888","schoolClassManagementAdd":"3077f851","schoolClassManagementEdit":"5d98dbd1","schoolEdit":"da2f20b8","schoolGradeManagement":"5d9cf4ea","schoolGradeManagementAdd":"f35c238b","schoolGradeManagementEdit":"99985146","schoolSet":"afaa1c29","schoolStudentsImport":"9dfeaba2","studentManagement":"83a538fe","studentManagementAdd~studentManagementEdit":"971cb0a5","studentManagementAdd":"44400c8e","studentManagementEdit":"016c6f19","studentTesthistory":"3db6f765","teacher":"9d52eae5","teacherAdd":"9b0ca710","teacherEdit":"db72be8a","teacherManage":"4774dc8c","teacherManageAdd":"9133a3b8","teacherManageEdit":"ea74cf0c","home":"be7bebd4","chunk-2d215faa":"31d6cfe0","chunk-2d216214":"31d6cfe0","chunk-60a5769a":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([1,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
